module.exports = __webpack_public_path__ + "assets/img/17life_logo.4705da73.svg";